import { TZDate } from '@date-fns/tz';
import { cn } from 'noddi-ui-common';
import { NoddiButton, NoddiDatePicker, useIsWithinTailWindBreakpoint } from 'noddi-ui-web';

type Props = {
  translations: { jumpToDateTriggerText: string };
  skipToDate: TZDate;
  setSkipToDate: (skipToDate: TZDate) => void;
  maxDate: TZDate;
  minDate: TZDate;
  timeZone: string;
};

export const GoToDatePicker = ({ translations, setSkipToDate, skipToDate, maxDate, minDate, timeZone }: Props) => {
  const isLg = useIsWithinTailWindBreakpoint('lg');

  const handleDateChange = (newDate: Date | undefined) => {
    if (newDate) {
      const tzDate = new TZDate(newDate, timeZone);
      setSkipToDate(tzDate);
    }
  };

  return (
    <NoddiDatePicker
      customTrigger={
        <NoddiButton
          className='h-9 md:h-8'
          size='small'
          startIcon='Calendar'
          data-track='clickedGoToDateTimePicker'
          variant='outline'
        >
          {translations.jumpToDateTriggerText}
        </NoddiButton>
      }
      date={skipToDate}
      onDateChange={handleDateChange}
      hidden={{
        after: maxDate,
        before: minDate
      }}
      popoverContentClassName={cn(isLg ? 'mr-5' : 'mr-20')}
      timeZone={timeZone}
    />
  );
};
